<template>
  <Modal
    title="Require User Logins"
    :back="backLink"
    size="small"
  >
    <div class="body">
      <p>A new parent page with a login view will be added.</p>

      <form v-if="showRoleAccess">
        <div>
          <label>
            Which logged-in users can access this page?
          </label>
          <div class="input-labels tw-input-labels">
            <label><input
              v-model="limit_profile_access"
              type="radio"
              :value="false"
            >Give permission to all users</label>
            <label><input
              v-model="limit_profile_access"
              type="radio"
              :value="true"
            >Limit permissions to specific user roles</label>
          </div>

          <div
            v-if="limit_profile_access"
            id="quickstart-permissions"
            data-cy="quickstart-permissions-picker"
            class="input-labels"
            style="margin-top: .5em;"
          >
            <MultipleChoice
              v-model="allowed_profiles"
              :input="{format: {type: `multi`, options: roleObjectOptions}}"
            />
          </div>
        </div>
      </form>

      <div class="submit-buttons flex justify-end pt-0">
        <SubmitButton
          classes="button save rounded-lg"
          button-text="Add a login"
          :is-loading="submitIsLoading"
          @submit="onSubmit"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RequestUtils from '@/components/util/RequestUtils';
import Modal from '@/components/ui/Modal';
import SubmitButton from '@/components/renderer/shared/SubmitButton';
import MultipleChoice from '@/components/renderer/form/inputs/MultipleChoice';
import { trackMainEvent } from '@/lib/rudderstack-helper';
import { trackIntercomEvent } from '@/lib/intercom-helper';

export default {
  components: {
    Modal,
    SubmitButton,
    MultipleChoice,
  },
  mixins: [
    RequestUtils,
  ],
  props: {
    backLink: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      submitIsLoading: false,
      limit_profile_access: false,
      allowed_profiles: [],
    };
  },
  computed: {
    ...mapGetters([
      'roleObjects',
    ]),
    showRoleAccess() {
      return this.roleObjects.length > 0;
    },

    roleObjectOptions() {
      return this.roleObjects.map((roleObject) => ({
        label: roleObject.name,
        value: roleObject.get('profile_key'),
      }));
    },
  },
  methods: {
    ...mapActions('page/navVisibility', [
      'showNavChildren',
    ]),
    onSubmit() {
      const { activePage } = this.$store.getters;
      const pageKey = activePage.key;

      const pageViews = activePage.views.map((view) => view.raw());

      this.submitIsLoading = true;

      this.commitRequest({
        request: () => window.Knack.Api.updatePageLoginSettings(pageKey, pageViews, true, this.limit_profile_access, this.allowed_profiles),
        globalLoading: false,
        onSuccess: async () => {
          await trackMainEvent('add_login_to_page', {
            page_name: activePage.name,
            page_id: activePage.key,
          }); // Main business event for adding login to page

          trackIntercomEvent('add_login_to_page');
          this.submitIsLoading = false;

          if (activePage.parent) {
            await this.showNavChildren(activePage.parent.key);
          }

          // Reload the active page.
          // This fixes a reactivity issue when from the Page Access Info Card add login flow.
          await this.$store.dispatch('setActivePageByKey', { pageKey });

          this.$router.push(`/pages/${pageKey}`);
        },
      });
    },
  },
};
</script>
